import type React from 'react';

// Defaults match legacy shared Rating.tsx (size 24px, gap 0.15rem). Callers that
// need legacy SC / product-card geometry pass 19px + a 5-6px gap (see consumers).
export function StarRating({
  value,
  size = '24px',
  gap = '0.15rem',
  className,
}: {
  value?: number;
  size?: string;
  gap?: string;
  className?: string;
}): React.JSX.Element | null {
  if (!value) return null;

  return (
    <span
      aria-label={`${value} out of 5`}
      className={`star-rating${className ? ` ${className}` : ''}`}
      style={
        {
          '--value': value,
          '--star-fill': '#008254',
          '--star-rating-gap': gap,
          '--star-rating-size': size,
        } as React.CSSProperties
      }
    />
  );
}
